import type { AccountMenuItem as AccountMenuItemData } from './accountMenuData';
import type { FocusEvent, ReactElement } from 'react';

import { memo } from 'react';

import { AccountMenuItem } from './AccountMenuItem';
import { S } from './accountMenuStyles';

const MENU_TITLE_ID = 'desktop-account-menu-title';

type AccountMenuDropdownProps = {
  activeLinks: AccountMenuItemData[];
  menuTitle?: string;
  isOpen: boolean;
  expandedItems: Record<string, boolean>;
  onToggleItem: (itemKey: string) => void;
  onClose: () => void;
  onBlur: (event: FocusEvent<HTMLDivElement>) => void;
};

const AccountMenuDropdownComponent = ({
  activeLinks,
  menuTitle,
  isOpen,
  expandedItems,
  onToggleItem,
  onClose,
  onBlur,
}: AccountMenuDropdownProps): ReactElement => (
  <S.Dropdown
    id="desktop-account-menu-dropdown"
    $isOpen={isOpen}
    aria-hidden={!isOpen}
    onBlur={onBlur}
    data-testid="account-menu-dropdown"
  >
    {menuTitle && <S.DropdownTitle id={MENU_TITLE_ID}>{menuTitle}</S.DropdownTitle>}

    <S.MenuList aria-labelledby={menuTitle ? MENU_TITLE_ID : undefined}>
      {activeLinks.map(item => {
        const itemKey = item.uid || item.label;

        return (
          <AccountMenuItem
            key={itemKey}
            item={item}
            isExpanded={!!expandedItems[itemKey]}
            onToggle={onToggleItem}
            onClose={onClose}
          />
        );
      })}
    </S.MenuList>
  </S.Dropdown>
);

export const AccountMenuDropdown = memo(AccountMenuDropdownComponent);
